let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("dFNh6")]).then(() => parcelRequire('8g9bp'));